/******/ (() => { // webpackBootstrap
/*!*******************************************************!*\
  !*** ./zrc/scripts/templates/product/product-faqs.js ***!
  \*******************************************************/
class ProductFaqs extends window.HTMLElement {
  connectedCallback() {
    this.container = this;
    this.faqAccordions();
  }
  faqAccordions() {
    $(".faq-question").click(function () {
      $(".is-active").removeClass("is-active");
      $(".faq-indicator").text("+");
      if ($('.faq-answer').is(':visible')) {
        $(".faq-answer").slideUp(300);
      }
      if ($(this).next(".faq-answer").is(':visible')) {
        $(this).next(".faq-answer").slideUp(300);
      } else {
        $(this).next(".faq-answer").slideDown(300);
        $(this).children(".faq-indicator").addClass("is-active");
        $(this).children(".faq-indicator").text("-");
      }
    });
  }
}
if (window.customElements.get('product-faqs') == null) {
  window.customElements.define('product-faqs', ProductFaqs);
}
/******/ })()
;